<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineScheduleConfirmSection from '../DisciplineScheduleConfirmSection.vue'
import { useDisciplineScheduleChosenTutor } from '../../model/discipline-schedule-chosen-tutor.hook'
import { useModalDisciplineScheduleCreateConfirm } from '../../model/modal-discipline-schedule-create-confirm.hook'

defineOptions({
  name: 'ModalDisciplineScheduleCreateConfirm',
})

const {
  refKidName,
  refIsSaving,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleCreateConfirm()

const {
  refTutor,
  refTutorName,
  refTutorUrl,
  refSlots,
} = useDisciplineScheduleChosenTutor()
</script>

<template>
  <ModalDefault
    show
    title="Assign tutor"
    :loading="refIsSaving"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-confirm">
      <div class="modal-discipline-schedule-confirm__info">
        <AppText
          name="body1"
          class="modal-discipline-schedule-confirm__text"
        >
          Are you sure you want to assign tutor
          <LinkTextPrimaryMedium
            v-if="refTutor && refTutorUrl"
            :href="refTutorUrl"
          >
            {{ refTutorName }}
          </LinkTextPrimaryMedium>
          for kid {{ refKidName }}?
        </AppText>
        <AppText name="body1">
          Check schedule and confirm changes
        </AppText>
      </div>
      <div class="modal-discipline-schedule-confirm__box">
        <DisciplineScheduleConfirmSection
          title="Weekly schedule:"
          :items="refSlots"
        />
      </div>
    </div>
    <template #controls>
      <BtnPrimary
        text="Create schedule"
        color="emerald"
        :disabled="refIsSaving"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        :disabled="refIsSaving"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineScheduleConfirm.scss" />
